import React from "react";
//import axios from "axios";
import CodeExample from "../../partials/content/CodeExample";
import { Table } from "react-bootstrap";
import { getBusinessEntities } from "../../crud/auth.crud";

export default class BusinessEntity extends React.Component {
  state = {
    businessEntities:[]
  }
  componentDidMount()
  {

    getBusinessEntities().then(response => response.data)
    .then((data) => {
      this.setState({ businessEntities: data })
     })
  }
  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <CodeExample  beforeCodeTitle="Business Entity">
              <div className="kt-section">
               
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      
                      <th>Name</th>
                      <th>Description</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.businessEntities.map((entity) => (
                    <tr>
                      
                      <td>{entity.businessEntity}</td>
                      <td>{entity.description}</td>
                    
                    </tr>
                    ))}
                </tbody>
                </Table>
              </div>
            </CodeExample>
          </div>
         
        </div>

      

       
      </>
    );
  }
}
